module.exports = __webpack_public_path__ + "static/media/celeris.35acc142.svg";